import React, { useContext, useEffect } from 'react';
import { css } from '@emotion/css';
import { AuthContext } from 'index';

const MitIDLoginPage = () => {
    const auth = useContext(AuthContext);

    useEffect(() => {
        console.log('Login page opened');
        
        auth.redirect.authorize({
            acrValues: 'urn:grn:authn:dk:mitid:low',
            scope: 'openid ssn',
            loginHint: 'action:login',
            uiLocales: 'da-DK',
        });
    }, [auth]);

    return (
        <div className={styles.content}></div>
    );
};

const styles = {
    content: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '3rem',
    }),
    logo: css({
        width: '10rem',
        objectFit: 'contain',
    }),
};

export default MitIDLoginPage;
